import { LoadLayoutStore } from "@core/presentation/components/feedback/load-layout/load-layout.store.ts";
import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { makeObservable, observable, runInAction } from "mobx";

@injectable()
export class LoadLayoutViewModel extends BaseViewModel {
    @observable
    loading = false;

    constructor() {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.addSub(
            LoadLayoutStore.loading.subscribe((loading) => {
                runInAction(() => {
                    this.loading = loading;
                });
            }),
        );
    }
}
